
function setupTinyMCE(opts = {})
{
	const merged_options = Object.assign({
		selector: 'textarea.richtext',
		plugins: 'chargeover_image link paste code autoresize',
		//skin: 'oxide',
		skin_url: $('body').data('assetsurl') + '/build/tinymce/skin',
		content_css: false,
		statusbar: false,
		height: 600,
		menubar: false,
		toolbar: 'pastetext | styleselect fontsizeselect fontselect | bold italic underline forecolor removeformat | link unlink chargeover_image insertbutton | alignleft aligncenter alignright | code',
		relative_urls: false,
		remove_script_host: false,
		convert_urls: false,
		branding: false,
		fontsize_formats: '6p 7pt 8pt 9pt 10pt 11pt 12pt 14pt 18pt 24pt 36pt',
		font_formats: 'Andale Mono=andale mono,times;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;Courier New=courier new,courier;Georgia=georgia,palatino;Helvetica=helvetica;Impact=impact,chicago;Sans-Serif=sans-serif;Symbol=symbol;Tahoma=tahoma,arial,helvetica,sans-serif;Terminal=terminal,monaco;Times New Roman=times new roman,times;Trebuchet MS=trebuchet ms,geneva;Verdana=verdana,geneva',

		setup: function (editor) {

			// Add our custom "create a button" plugin
			editor.ui.registry.addButton('insertbutton', {
				icon: 'plus',
				tooltip: 'Insert button',
				onAction: function()
				{
					// Open window
					var win = editor.windowManager.open({
						title: 'Insert Button',
						initialData: {
							bgcolorpicker: '#236FA1',
							linkcolorpicker: '#FFFFFF'
						},
						body: {
							type: 'panel',
							items: [
								{
									type: 'input',
									name: 'button_text',
									label: 'Button Text',
								},
								{
									type: 'selectbox',
									name: 'custom_link_option',
									label: 'Button Link',
									items: [
										{
											text: 'Update Payment Method',
											value: 'updatePaymentLinkSelected'
										},
										{
											text: 'View Invoice',
											value: 'invoiceLinkSelected'
										},
										{
											text: 'Custom Link',
											value: 'customLinkSelected'
										}
									],
								},
								{
									type: 'input',
									name: 'custom_link_href',
									disabled: true,
									label: 'Custom Link'
								},
								{
									type: 'colorinput',
									name: 'bgcolorpicker',
									label: 'Background Color'
								},
								{
									type: 'colorinput',
									name: 'linkcolorpicker',
									label: 'Text Color'
								}/*,
								{
									type: 'label',
									label: 'Errors',
									items: [
										{
											type: 'alertbanner', // component type
											level: 'error',
											text: 'An <strong>informative</strong> message to the user',
											//url: 'http://my.url',
											icon: 'question'
										}

									]
								},*/
							]
						},

						buttons: [ // A list of footer buttons
							{
								type: 'submit',
								text: 'OK',
								primary: true
							}
						],

						onChange: function(e, details) {

							if (details.name == 'custom_link_option')
							{
								var link_option = e.getData().custom_link_option.valueOf();

								if (link_option == 'invoiceLinkSelected' ||
									link_option == 'updatePaymentLinkSelected')
								{
									e.setData({ custom_link_href: ''});
									e.disable('custom_link_href');
								}
								else
								{
									e.enable('custom_link_href');
								}
							}

						},

						onSubmit: function (e) {
							var customLinkHref = e.getData().custom_link_href.valueOf();
							var optionSelected = e.getData().custom_link_option.valueOf();
							var url = '';

							// Only use the custom link if it's not left blank when selected as an option.
							// Use update Payment method as default.
							switch (optionSelected) {
								case 'invoiceLinkSelected':
									url = '{{invoice.url_permalink}}';
									break;
								case 'customLinkSelected':
									if (!(customLinkHref == '' || customLinkHref == 'http://' || customLinkHref == 'https://')) {
										url = customLinkHref;
									}
									break;
								default:
									url = '{{customer.url_paymethodlink}}';
									break;
							}

							if (optionSelected == 'invoiceLinkSelected' || optionSelected == 'updatePaymentLinkSelected') {
								// Do nothing/continue the script if the URL is valid.
								;
							} else if (optionSelected == 'customLinkSelected' && validateURL(url)) {
								// Do nothing/continue the script if the URL is valid.
								;
							} else {
								// If not, write an error message to the error div and prevent form submission.
								editor.windowManager.alert('Please enter a full URL.');
								return false;
							}
							// Insert content when the window form is submitted
							editor.insertContent('<table class="btn-primary" style="font-family: sans-serif; font-size: 100%; line-height: 1.6em; margin: 0; padding: 0; margin-bottom: 10px; width: auto !important;" border="0" cellspacing="0" cellpadding="0">\n' +
								'<tbody>\n' +
								'<tr style="font-family: sans-serif; font-size: 100%; line-height: 1.6em; margin: 0; padding: 0; border: 0;">\n' +
								'<td style="font-family: sans-serif; font-size: 14px; line-height: 1.6em; margin: 0; padding: 0; border: 0; background-color: ' + e.getData().bgcolorpicker + '; border-radius: 25px; text-align: center; vertical-align: top;"><a style="font-family: sans-serif; font-size: 100%; line-height: 2; margin: 0; padding: 0; color: ' + e.getData().linkcolorpicker + '; background-color: ' + e.getData().bgcolorpicker + '; border: solid 1px ' + e.getData().bgcolorpicker + '; border-radius: 25px; border-width: 10px 20px; display: inline-block; cursor: pointer; font-weight: bold; text-decoration: none;" href=' + url + '>' + e.getData().button_text + '</a></td>\n' +
								'</tr>\n' +
								'</tbody>\n' +
								'</table>\n');

							e.close();
						}
					});

				}

			});
		}
	}, opts);
	tinymce.init(merged_options);
}

function validateURL(field) {

	var r = new RegExp('^(?:[a-z]+:)?//', 'i');

	var mergeTag = new RegExp('^(?:\{\{).+(?:\}\})$');
	if (field) {
		if (r.test(field))
		{
			return true;
		}
		else if (mergeTag.test(field))
		{
			return true;
		}
		else
		{
			return false;
		}
	}
}

//
// WARNING WARNING WARNING
//
//
// This is a very lightly modified version of the default TinyMCE 5.x image plugin. It does the same thing as the
// default plugin EXCEPT that it swaps the URL of the image to _a URL on the ChargeOver domain_ that the proxies the
// image.
//
// This is done for a few reasons:
//  * we can validate that it's actually an image, and not something malicious
//  * we can leave a really strict Content-Security-Policy in place which in general disallows embedding images in ChargeOver... but still show external customer logos via the proxy
//
//
require('./tinymce/chargeover_image.plugin.js');

// Export the setup function
module.exports = {
	setupTinyMCE: setupTinyMCE
}
